import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import { persistCache } from 'apollo-cache-persist';
import { withClientState } from 'apollo-link-state';
import { concat, split } from "apollo-link";
import { setContext } from "apollo-link-context";
import { ApolloClient, ApolloLink } from 'apollo-boost'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { SubscriptionClient } from "subscriptions-transport-ws";


import { logout } from "views/auth/components/Logout"

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAQPHL_ENDPOINT })

const AuthLink = (operation, next) => {
  const token = localStorage.getItem('APN_AUTH_TKN');

  operation.setContext(context => ({
    ...context,
    headers: {
      ...context.headers,
      Authorization: `${token}`,
    },
  }));

  return next(operation);
};

const LogoutLink = onError(({ operation,networkError, graphQLErrors }) => {
  if (graphQLErrors){
    graphQLErrors.map((message, location) => {
        if (message.message.includes("Expired") && !message.message.includes("Pin")){
          alert("Session expired!");
          localStorage.clear();
          window.location.reload();
        }
    });
  }
  
  // if (networkError){
  //   if(operation.operationName != "authProcess" && operation.operationName != null){
  //     if ((networkError.toString()).includes("Failed to fetch")){
  //         alert("Server is down. Redirecting to Login Page");
  //         localStorage.clear();
  //         window.location.reload();
  //     }
  //   }
  // }  

})

export const subClient = new SubscriptionClient(`${process.env.REACT_APP_SUBSCRIPTION_ENDPOINT}`, {
  reconnect: true
});

const wsLink = new WebSocketLink(subClient);

const tl = ApolloLink.from([
  LogoutLink, 
  AuthLink,
  httpLink
]);

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query)
    return kind === 'OperationDefinition' && operation === 'subscription'
  },
  wsLink,
  tl
)

const cache = new InMemoryCache()

// Set Storage
persistCache({
  cache,
  storage: window.localStorage,
});

export const client = new ApolloClient({
  link,
  cache: cache
});




// WEBPACK FOOTER //
// ./src/client.js